<section class="hero is-primary">

    <div class="hero-body" style="position:relative;">
        <a id="catalogos" (click)="obtenerCatalogos('grupo', 'cat_grupos'); obtenerCatalogos('carrera', 'cat_carreras');"></a>
        <nav class="level">
            <!-- Left side -->
            <div class="level-left">
                <div class="level-item">
                    <p class="title">
                        <span *ngIf="!cargando" class="icon is-medium">
                            <i class="{{icono}}"></i>
                        </span> Reporte "{{modulo_actual}}"
                    </p>
                </div>

            </div>
            <div class="level-right">

                <a class="navbar-item tooltip" (click)="imprimir()">
                    <span class="icon fa-2x">
                        <i class="icon-printer2"> </i>
                    </span>
                    <span class="tooltiptext is-hidden-touch">&nbsp; PDF</span>
                </a>

                <a class="navbar-item tooltip" (click)="excel()">
                    <span class="icon fa-2x">
                        <i class="fa fa-file-excel-o"> </i>
                    </span>
                    <span class="tooltiptext is-hidden-touch">&nbsp; EXCEL</span>
                </a>

                <button class="navbar-item is-success tooltip" (click)="buscar()" [disabled]="cargando">
                    <span class="icon fa-2x has-text-black">
                        <i class="icon-search3"> </i>
                    </span>
                    <span class="tooltiptext is-hidden-touch">&nbsp; Buscar</span>
                </button>
            </div>
        </nav>
        <div class="container is-fluid">
            <nav class="navbar is-transparent">
                <div class="navbar-brand">
                    <span class="navbar-burger burger" [ngClass]="{'is-active': activarReporte}" data-target="activarReporte" (click)="activarReporte = !activarReporte">
                        <span></span>
                    <span>
                            </span>
                    <span></span>
                    </span>
                </div>

                <div id="activarReporte" class="navbar-menu" [ngClass]="{'is-active': activarReporte}">
                    <div class="navbar-start" style="width:100%">
                        <div class="navbar-item">

                            Tiempo:
                            <div class="select" style="float:right">
                                <select class="select" [(ngModel)]="rango">
                                    <option *ngFor="let val of rangos_fecha" value="{{val.id}}">{{ val.nombre }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="navbar-item">
                            Desde:
                            <input class="input" [value]="fecha_desde" [(ngModel)]="desde" type="date" placeholder="Fecha desde" />
                        </div>

                        <div class="navbar-item">
                            Hasta:
                            <input class="input" [value]="fecha_actual" [(ngModel)]="hasta" type="date" placeholder="Fecha hasta" />
                        </div>

                        <div class="navbar-item" *ngIf="ruta != 'resumen/adeudos'">

                            Tipo:
                            <div class="select" style="float:right">
                                <select class="select" [(ngModel)]="tipo">
                                    <option value="0">Todos</option>
                                    <option value="1">Cancelados (Baja)</option>
                                    <option value="2">Eliminados</option>
                                </select>
                            </div>

                        </div>

                        <div class="navbar-item">
                            Buscar:
                            <input class="input" [(ngModel)]="texto" />
                        </div>
                    </div>
                </div>
            </nav>
            <nav class="navbar is-transparent">
                <div class="navbar-brand">
                    <span class="navbar-burger burger" [ngClass]="{'is-active': activarReporte}" data-target="activarReporte" (click)="activarReporte = !activarReporte">
                        <span></span>
                    <span>
                            </span>
                    <span></span>
                    </span>
                </div>

                <div id="activarReporte" class="navbar-menu" [ngClass]="{'is-active': activarReporte}">

                    <div class="navbar-start" style="width:100%" *ngIf="ruta == 'resumen/adeudos'">
                        <div class="navbar-item" *ngIf="ruta == 'resumen/adeudos'">
                            Estatus:
                            <select class="select" [(ngModel)]="estatus">
                                <option value="">Todos</option>
                                <option value="ACTIVO" >ACTIVO</option>
                                <option value="BAJA" >BAJA</option>
                            </select>
                        </div>

                        <div class="navbar-item" *ngIf="ruta == 'resumen/adeudos'">
                            Grupo:
                            <select class="select" [(ngModel)]="grupo">
                                <option value="">Todos</option>
                                <option value="{{(item.clave) + ' ' + item.nombre }}" *ngFor="let item of cat_grupos; let i=index">{{(item.clave) + " " + item.nombre }}</option>
                            </select>
                        </div>
                        <div class="navbar-item" *ngIf="ruta == 'resumen/adeudos'">
                            Carrera:
                            <select class="select" [(ngModel)]="carrera">
                                <option value="">Todos</option>
                                <option value="{{item.nombre }}" *ngFor="let item of cat_carreras; let i=index">{{item.nombre }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </nav>
        </div>

    </div>
</section>
<a id="logo64" (click)="asignarLogos(logos64); "></a>
<div class="notification is-danger" *ngIf="error_busqueda">
    ¡Ocurrio un error al intentar buscar!
    <strong>Por favor</strong>, intentelo de nuevo
</div>
<div class="notification is-black" *ngIf="sin_resultado != ''">
    ¡Mesaje del servidor!
    <strong>{{sin_resultado}}</strong>
</div>
<div class="is-fullwidth has-text-centered" *ngIf="cargando">
    <br>
    <span class="tag is-primary is-large ">
        <span class="icon">
            <i class="icon-worldwide fa-spin"></i>
        </span> &nbsp;
    <span>Cargando...</span>
    </span>
    <br>
    <br>
</div>
